export default {
    "hired-products": "Produtos contratados",
    products: "Produtos",
    "other-rock-products": "Outros produtos da Rock",
    "renewal-date": "Data de renovação",
    "no-offers": "Sem ofertas disponíveis",
    "you-dont-have": "Você não tem",
    yet: "ainda",
    open: "Abrir",
    "studio-description": "Gerencie toda sua agência em um único lugar.",
    "university-description": "Desenvolva suas habilidades em Marketing Digital e de Conteúdo",
    "stage-description": "Solução WordPress sem complicações para profissionais de marketing",
    "gtn-description": "Amplie sua atuação e desenvolva sua carreira de freelancer enquanto desfruta as melhores oportunidades de trabalho na plataforma Rock Content",
    "ion-description": "Diferencie sua estratégia de marketing usando Conteúdo Interativo",
    "live-description": "Maximize os resultados de suas Lives com experiências ao vivo sob medida.",
};
